module.exports = __webpack_public_path__ + "r-v3/img/ml_36_00_over.51010200.jpg";